import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export default function CheckOrder() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="eyebrow mb-3">Cek order</p>
      <h1 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-800">Masukkan kode order</h1>
      <p className="mt-3 text-slate-600 leading-relaxed">Kode dikirim saat kamu membuat order, formatnya seperti CK-7F3K9Q.</p>
      <form onSubmit={(e) => { e.preventDefault(); if (code.trim()) navigate(`/order/${code.trim().toUpperCase()}`); }} className="mt-8 flex gap-2">
        <input className="input-soft uppercase tracking-wider" placeholder="CK-XXXXXX" value={code} onChange={(e) => setCode(e.target.value)} data-testid="check-order-input" />
        <button className="btn-primary px-5" data-testid="check-order-submit"><Search size={18} strokeWidth={1.5} /></button>
      </form>
    </div>
  );
}
